import {
  CustomizationGroupStatusSchema,
  type CustomizationGroupStatus as GeneratedCustomizationGroupStatus
} from '~/services/api/generated'

export type CustomizationGroupStatus = GeneratedCustomizationGroupStatus

export const CustomizationGroupStatus = {
  DRAFT: CustomizationGroupStatusSchema.enum.draft,
  PUBLISHED: CustomizationGroupStatusSchema.enum.published
}

export const CustomizationGroupStatusValues = [
  CustomizationGroupStatusSchema.enum.draft,
  CustomizationGroupStatusSchema.enum.published
]
